module.exports = __webpack_public_path__ + "fonts/Raleway-Bold.7802d8b2.ttf";